import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_ZONE } from "./apiRoutes";

interface GetProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getPropertyZoneByCommunityId = async (communityId: string) => await axiosAuth.get(`${PROPERTY_ZONE(communityId)}`);

const useGetPropertyZoneByCommunityId = ({
  communityId,
  queryParams
}: GetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-zones"],
    queryFn: () => getPropertyZoneByCommunityId(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyZoneByCommunityId;
